// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBwqVV9pM18yGSNPULLYsJjqI-tnkMxAb0',
    authDomain: 'almastu-dmd.firebaseapp.com',
    databaseURL: 'https://almastu-dmd.firebaseio.com',
    projectId: 'almastu-dmd',
    storageBucket: 'almastu-dmd.appspot.com',
    messagingSenderId: '772128718738',
    appId: '1:772128718738:web:e7b649388f01b2a6f14b4b',
    measurementId: 'G-S87ZV7E6S7'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
